// extracted by mini-css-extract-plugin
module.exports = {"always":"styles_always__6NuYN","animated":"styles_animated__bTMg5","anim":"styles_anim__SSxjq"};